import { render, staticRenderFns } from "./ClientWeightHeight.vue?vue&type=template&id=caeade0e&scoped=true"
import script from "./ClientWeightHeight.vue?vue&type=script&lang=js"
export * from "./ClientWeightHeight.vue?vue&type=script&lang=js"
import style0 from "./ClientWeightHeight.vue?vue&type=style&index=0&id=caeade0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeade0e",
  null
  
)

export default component.exports